import CustomDialog from "../../components/general/CustomDialog";
import React from "react";
import {useTranslation} from "react-i18next";
import CustomButton from "../../components/general/CustomButton";
import {useNavigate} from "react-router";
import {Help} from "@mui/icons-material";
import {Tooltip} from "@material-tailwind/react";

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    identification?: string;
    setOpenComponent?: React.Dispatch<React.SetStateAction<boolean>>;
    setValue?: React.Dispatch<React.SetStateAction<number>>;
}
export default function TermsConditions({open, setOpen, identification, setOpenComponent, setValue}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const history = useNavigate();
    const [openTerms, setOpenTerms] = React.useState(false)

    function dialogTermsConditions() {
        return(
            <CustomDialog
                open={openTerms}
                setOpen={setOpenTerms}
                size={'xs'}
                title={`${t('identification')}: ${identification}`}
                body={
                    <div className={'flex flex-col justify-center gap-4'}>
                        <div className={'flex flex-row'}>
                            <h3 className={'text-header'}>{t('accept-terms-conditions')}</h3>
                            <Tooltip className={"bg-headerMenus z-[99999]"} content={t('terms-conditions')}>
                                <Help className={'text-header ml-auto cursor-pointer'}/>
                            </Tooltip>
                        </div>
                        <div className={'flex flex-row gap-2 justify-center'}>
                            <CustomButton className={'bg-header'} text={t('cancel')}
                                          onClick={() => {setOpen(false)}}/>
                            <CustomButton className={'bg-empColorSecondary'} text={t('accept')}
                                          onClick={() => {
                                              if(setValue) {
                                                  setValue(0)
                                              }
                                              if (identification && identification?.length < 13) {
                                                  history(`/dashboard/${identification}`)
                                              } else {
                                                  history(`/dashboard-ruc/${identification}`)
                                              }
                                              if(setOpenComponent) setOpenComponent(false)
                                              setOpen(false)
                                          }}/>
                        </div>
                    </div>
                }
            />
        )
    }

    return(
        <>
            {openTerms && dialogTermsConditions()}
            <CustomDialog
                size={'xs'}
                title={`${t('warning')}`}
                body={
                    <div className={'flex flex-col justify-center gap-4'}>
                        <div className={'flex flex-row'}>
                            <h3 className={'text-headerMenus'}>{`¿${t('confirm-consult')} ${identification}?`}</h3>
                        </div>
                        <div className={'flex flex-row gap-2 justify-center'}>
                            <CustomButton className={'bg-header'} text={t('cancel')}
                                          onClick={() => {
                                              setOpen(false)
                                          }}/>
                            <CustomButton className={'bg-empColorSecondary'} text={t('continue')}
                                          onClick={() => {
                                              if (identification && identification.length >= 13) {
                                                  history(`/dashboard-ruc/${identification}`);
                                                  if (setOpenComponent) setOpenComponent(false)
                                              } else {
                                                  setOpenTerms(true)
                                              }
                                          }}/>
                        </div>
                    </div>
                }
                {...{open, setOpen}}
            />
        </>
    )
}
